import { _$, _$$ } from "./shared"

class Navigation {
    constructor() {

        // $('header.c-page-header').data('scroll-offset', $('.c-page-header__bar').height() + parseInt(getComputedStyle(document.querySelector('.c-row')).marginBottom));

        _$$('[data-navigation="launcher"]').forEach(function(el){
            el.onclick = function(e){
                _$('body').classList.add('has-navigation')
                $('body').trigger('revealOffcanvas')
            }
        })
        _$('[data-navigation="locations"]').onclick = function(){
            _$('body').classList.add('has-locations')
            $('body').trigger('revealOffcanvas')
        }
        _$$('[data-navigation="close"]').forEach(function(el){
            el.onclick = function(e){
                _$('body').classList.remove('has-navigation')
                _$('body').classList.remove('has-locations')
            }
        })

        // _$('[data-navigation="close"]').onclick = function(){
        //     _$('body').classList.remove('has-navigation')
        //     _$('body').classList.remove('has-locations')
        // }

        _$$('[data-navigation="has-children"]').forEach(function(el){
            el.onclick = function(e){
                e.preventDefault()
                this.parentElement.querySelector('.sub-menu').classList.add('is-active')
                $('body').trigger('revealOffcanvas')
            }
        })
        _$$('[data-navigation="back"]').forEach(function(el){
            el.onclick = function(e){
                e.preventDefault()
                this.closest('.sub-menu').classList.remove('is-active')
                $('body').trigger('revealOffcanvas')
            }
        })

        let elements = _$$('[aria-current="page"]');

        // Check if any of the elements have a grandparent with the `.menu` class
        const hasMenuGrandparent = Array.from(elements).some(el => 
            el.parentElement?.parentElement?.classList.contains('menu')
        );
        
        const hasMenuSibling = Array.from(elements).some(el => 
            el.nextElementSibling?.classList.contains('sub-menu')
        );

        if (!hasMenuGrandparent || hasMenuSibling) {
            elements.forEach(el => {
                let elSibling = el ? el.nextElementSibling : false;

                // Traverse up the DOM tree and add 'is-active' class to parent sub-menus
                while (el = el ? el.parentElement : false) {
                    if (el.classList.contains('sub-menu')) {
                        el.classList.add('is-active');
                    }
                }

                // Add 'is-active' class to sibling sub-menus
                if (elSibling && elSibling.classList.contains('sub-menu')) {
                    elSibling.classList.add('is-active');
                }
            });
        }
    }
}

export default Navigation
